import { rem } from "@mantine/core";
import { faSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";
import { forwardRef } from "react";
import { Icon } from "../icon";
import { IProps } from "./loader-icon.types";

/**
 * Loader icon component.
 * @param {MantineLoaderProps} props - The props for the loader icon component.
 * @returns {React.ReactNode} The loader icon component.
 */
const LoaderIcon = forwardRef<HTMLDivElement, IProps>(({ className, ...others }, ref) => {
    return <Icon ref={ref} className={className} icon={faSpinnerThird} fontSize={rem(22)} spin {...others} />;
});

LoaderIcon.displayName = "LoaderIcon";

export default LoaderIcon;
